// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IKeytipProps } from "@fluentui/react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { DirectionalHint, memoizeFunction } from "@fluentui/react";

import { getBoundingWindowWithPaddingFabric } from "@1js/window-util";
import type { AppKeytipProps } from "@1js/acui-keytip";

export const deriveMLRTopRowKeytipProps = memoizeFunction(
  (keytipProps?: AppKeytipProps, leftAlign?: boolean): AppKeytipProps => {
    if (keytipProps) {
      return {
        ...keytipProps,
        offset: leftAlign ? { x: 8, y: -17 } : undefined,
        calloutProps: {
          ...(keytipProps as IKeytipProps).calloutProps,
          gapSpace: 0,
          coverTarget: false,
          directionalHint: leftAlign
            ? DirectionalHint.topLeftEdge
            : DirectionalHint.topCenter,
          bounds: getBoundingWindowWithPaddingFabric,
        },
      };
    }
    return undefined;
  }
);

export const deriveMLRMiddleRowKeytipProps = memoizeFunction(
  (keytipProps?: AppKeytipProps, leftAlign?: boolean): AppKeytipProps => {
    if (keytipProps) {
      return {
        ...keytipProps,
        offset: leftAlign ? { x: 8, y: 0 } : undefined,
        calloutProps: {
          ...(keytipProps as IKeytipProps).calloutProps,
          gapSpace: 12,
          directionalHint: leftAlign
            ? DirectionalHint.topLeftEdge
            : DirectionalHint.topCenter,
          bounds: getBoundingWindowWithPaddingFabric,
        },
      };
    }
    return undefined;
  }
);

export const deriveMLRBottomRowKeytipProps = memoizeFunction(
  (keytipProps?: AppKeytipProps, leftAlign?: boolean): AppKeytipProps => {
    if (keytipProps) {
      return {
        ...keytipProps,
        offset: leftAlign ? { x: 8, y: 24 } : undefined,
        calloutProps: {
          ...(keytipProps as IKeytipProps).calloutProps,
          directionalHint: leftAlign
            ? DirectionalHint.bottomLeftEdge
            : DirectionalHint.bottomCenter,
          gapSpace: 0,
          coverTarget: false,
          bounds: getBoundingWindowWithPaddingFabric,
        },
      };
    }
    return undefined;
  }
);
